/* eslint no-inline-comments: 0 */

const ListSources = () => import( /* webpackChunkName: "group-stringer" */ `./sources/list.vue` );
const AddSources = () => import( /* webpackChunkName: "group-stringer" */ `./sources/add.vue` );
const EditSources = () => import( /* webpackChunkName: "group-stringer" */ `./sources/edit.vue` );

const ListDestinations = () => import( /* webpackChunkName: "group-stringer" */ `./destinations/list.vue` );
const AddDestination = () => import( /* webpackChunkName: "group-stringer" */ `./destinations/add.vue` );
const EditDestination = () => import( /* webpackChunkName: "group-stringer" */ `./destinations/edit.vue` );

const Settings = () => import( /* webpackChunkName: "group-stringer" */ `./settings.vue` );

export default {
	path: `stringer`,
	children: [
		{
			path: `sources`,
			name: `list-sources`,
			component: ListSources,
			meta: {
				title: `Sources`
			}
		},
		{
			path: `sources/new`,
			name: `add-source`,
			component: AddSources,
			meta: {
				title: `Add Source`
			}
		},
		{
			path: `sources/:uuid`,
			name: `edit-source`,
			component: EditSources,
			meta: {
				title: `Edit Source`
			}
		},
		{
			path: `destinations`,
			name: `list-destinations`,
			component: ListDestinations,
			meta: {
				title: `Destinations`
			}
		},
		{
			path: `destinations/new`,
			name: `add-destination`,
			component: AddDestination,
			meta: {
				title: `Add Destination`
			}
		},
		{
			path: `destinations/:uuid`,
			name: `edit-destination`,
			component: EditDestination,
			meta: {
				title: `Edit Destination`
			}
		},
		// Module-selector rebuild (2026-09-14): the sales@/support@/contact@
		// inbound-email queue's own list page and route used to be declared
		// here. Removed entirely, folded into the "Requests" tile's unified
		// list (assets/js/organizations/requests.vue) alongside four
		// sibling queue-consolidation types -- see that file's own doc
		// comment and organization_subscriptions/requests_list_api.go's.
		// Resolving a contact_request row still goes through
		// contact_requests.ResolveContactRequest, unchanged, now reached
		// only via admin/inbound_requests/resolve.
		{
			path: `settings`,
			name: `stringer-settings`,
			component: Settings,
			meta: {
				title: `Stringer Settings`
			}
		}
	]
};
